var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from "@angular/core";
import { BaseComponent } from "../../../../../common/components/base.component";
import { HubApiService } from "../../../../../services/hub.api.service";
import { ModalService } from "../../../../../common/services/modal.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, Validators } from "@angular/forms";
import { SearchGooglePlaceResultModalActions, SearchGooglePlaceResultModalData } from "./search.google.place.result.modal/search.google.place.result.modal.provider";
import { SearchGooglePlaceResultModalComponent } from "./search.google.place.result.modal/search.google.place.result.modal.component";
var SearchGooglePlaceComponent = /** @class */ (function (_super) {
    __extends(SearchGooglePlaceComponent, _super);
    function SearchGooglePlaceComponent(router, hubApiService, activatedRoute, formBuilder, modalService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.hubApiService = hubApiService;
        _this.activatedRoute = activatedRoute;
        _this.formBuilder = formBuilder;
        _this.modalService = modalService;
        _this.enabled = false;
        return _this;
    }
    SearchGooglePlaceComponent.prototype.ngOnInit = function () {
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.placeFormGroup = this.formBuilder.group({
            'placeName': [null, [Validators.required]],
        });
    };
    SearchGooglePlaceComponent.prototype.search = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var searchPlace, getBlocked, getAllowedPlaceCategories, result, actions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        searchPlace = this.hubApiService.searchGooglePlaceByName(this.hubName, this.placeName).toPromise();
                        getBlocked = this.hubApiService.getGooglePlaceBlockedCategories(this.hubName).toPromise();
                        getAllowedPlaceCategories = this.hubApiService.getAllowedPlaceCategories(this.hubName).toPromise();
                        return [4 /*yield*/, Promise.all([searchPlace, getBlocked, getAllowedPlaceCategories])];
                    case 1:
                        result = _a.sent();
                        $event.complete();
                        this.blockedCategories = result[1] ? result[1].value : '';
                        actions = {
                            confirm: function (event, data) {
                            }
                        };
                        this.modalService.show({
                            component: SearchGooglePlaceResultModalComponent,
                            providers: [
                                {
                                    provide: SearchGooglePlaceResultModalActions,
                                    useValue: actions
                                },
                                {
                                    provide: SearchGooglePlaceResultModalData,
                                    useValue: new SearchGooglePlaceResultModalData(result[0], this.hubName, this.blockedCategories, result[2])
                                },
                            ],
                            panelClass: 'width-modal-90p'
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return SearchGooglePlaceComponent;
}(BaseComponent));
export { SearchGooglePlaceComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.account/content.management/search.google.place/search.google.place.component.ts.pre-build-optimizer.js